import { render, staticRenderFns } from "./SendMessageTargetCheck.vue?vue&type=template&id=c3e89bc2&lang=pug"
import script from "./SendMessageTargetCheck.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports